import React from 'react'
import {useAuthContext} from './useAuthContext'
import Cookies from 'js-cookie';

export const useLogout = () => {
    const {dispatch} = useAuthContext()

    const logout = () =>{
        Cookies.remove('accessToken');

        //dispatch logout action
        dispatch({type: 'LOGOUT'})
    }

    return {logout}

}
